// skipcq: JS-W1028
import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { UserContext } from '../context/UserContext';
import PageLoadingIndicator from '../components/widgets/PageLoadingIndicator';
import { getVerifiedUserDestination } from '../utils/verifiedUserDestination';

/**
 * Sends signed-in brewers to the portal; keeps admin / anonymous paths consistent with GlobalAdminRoute.
 */
export default function RootRedirect() {
  const user = useContext(UserContext);

  if (user.isLoading) {
    return <PageLoadingIndicator title="Loading..." />;
  }

  if (!user.isLoggedIn) {
    return <Navigate to="/dashboard" replace />;
  }

  if (user.emailVerified !== true) {
    return <Navigate to="/verify-email" replace />;
  }

  return <Navigate to={getVerifiedUserDestination(user)} replace />;
}
